import React, { useEffect, useState } from "react";
import './RoleMaster.css';
import { useNavigate } from "react-router-dom";
import axios from "axios";

const RoleMaster = () => {
    const [roles, setRoles] = useState([]);
    const navigate = useNavigate();
    // Token you provided (for testing purposes)
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(`${baseUrl}/poims-user-roles`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // console.log(response);
            setRoles(response.data.data);



        } catch (error) {
            console.error("Error fetching roles:", error);
            alert("Failed to fetch roles");
        }
    };

    const handleAddButtonClick = () => {
        navigate('/addRole');
    };

    const handleEditButtonClick = (roleId, roleName) => {
        navigate('/editRole', { state: { roleId, roleName } });
    };

    const handleDeleteButtonClick = async (roleId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this role?");
        if (isConfirmed) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/roles/delete/${roleId}`);
                alert("Role deleted successfully");
                fetchRoles(); // Refresh the table after deletion
            } catch (error) {
                console.error("Error deleting role:", error);
                alert("Failed to delete role");
            }
        } else {
            //console.log("Delete operation canceled.");
        }
    };


    return (
        <div className="role-master">
            <div className="outside-role-master">
                {/* <h3>Role Master</h3> */}
            </div>
            <div className="role-master-table">
                <div className="inside-role-master">
                    <h3>Role Master</h3>
                </div>
                <div className="role-master-containerbody">
                    <div className="role-masterButtons">
                        <button className="btn-role-master" onClick={handleAddButtonClick}>ADD</button>
                    </div>
                </div>
                <div className="table-div">
                    <table className="fdbk-table">
                        <thead className="theadtr">
                            <tr>
                                <th>Role ID</th>
                                <th>Role Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {roles.map((role) => (
                                <tr key={role.roleId}>
                                    <td>{role.id}</td>
                                    <td>{role.roleName}</td>
                                    <td>
                                        <button className="editbutton" onClick={() => handleEditButtonClick(role.id, role.roleName)}>Edit</button>
                                        <button className="deleteButton" onClick={() => handleDeleteButtonClick(role.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RoleMaster;
